import React from 'react';
import PropTypes from 'prop-types';
import Routs from 'routs';
import { MixpanelConsumer } from 'react-mixpanel';

import MainHeader from './MainHeader/MainHeader';

import classes from './Layout.module.scss';

const Layout = ({ onOfNotif }) => {
  return (
    <div>
      <MixpanelConsumer>
        {mixpanel => <MainHeader onOfNotif={onOfNotif} mixpanel={mixpanel} />}
      </MixpanelConsumer>
      <main className={classes.layout}>
        <Routs onOfNotif={onOfNotif} />
      </main>
    </div>
  );
};

Layout.propTypes = {
  onOfNotif: PropTypes.func
};

export default Layout;
